export default __webpack_public_path__ + "static/media/work_web-sm@1x.7dd4c388.jpg";